// GIM-5454 (E2-5) / GIM-5449: SINGLE SOURCE OF TRUTH for the AVS per-field character
// rules + lengths (PRD v2.8 §11.12). This module is intentionally dependency-free (a leaf)
// so Helpers.sanitizeAvsField can derive the negated strip regex (`[^chars]`) for
// strip-on-input from it without pulling in heavier deps or creating an import cycle.
//
// Each field declares only its allowed inner character class as the string `chars` (what
// goes inside a `[...]` class) plus its `maxLength`.
//
// Disallowed across address-like fields: | & * @ , : ( ) ;  Allowed on address line: / ' . -
// CA accents (CA_ACCENT_CHARS) are part of every text field's allowed set so Quebec
// addresses survive untouched to the AVS call. To change a field's rule, edit `chars`
// (and the length) here and nowhere else.

// Canadian (esp. Quebec) accented letters that MUST be preserved through to the AVS call.
// Lower- and upper-case: à â ä è é ê ë î ï ô ö ù û ü ç (+ uppercase).
const CA_ACCENT_CHARS = 'àâäèéêëîïôöùûüçÀÂÄÈÉÊËÎÏÔÖÙÛÜÇ';

const AVS_FIELD_RULES = {
    address1: { chars: `A-Za-z0-9 ${CA_ACCENT_CHARS}/'.\\-`, maxLength: 30 },
    address2: { chars: `A-Za-z0-9 ${CA_ACCENT_CHARS}/'.\\-`, maxLength: 30 },
    city: { chars: `A-Za-z ${CA_ACCENT_CHARS}'.\\-`, maxLength: 30 },
    state: { chars: 'A-Za-z', maxLength: 20 },
    postalCode: { chars: 'A-Za-z0-9 \\-', maxLength: 10 },
    firstName: { chars: `A-Za-z ${CA_ACCENT_CHARS}'\\-`, maxLength: 30 },
    lastName: { chars: `A-Za-z ${CA_ACCENT_CHARS}'\\-`, maxLength: 30 },
    // Phone is digits-only, capped at 10 (AC: "phone accepts 10 digits only") — strip-on-input keeps
    // only 0-9 and truncates at maxLength, so a full 10-digit entry is what reaches AVS.
    phone: { chars: '0-9', maxLength: 10 }
};

export {
    CA_ACCENT_CHARS, AVS_FIELD_RULES
};
